import React, { useState } from 'react';

/* Shared primitives for the homepage's data-product design (promoted from the
   design lab 2026-08-04). Receipt is the page's signature element: open on
   hero items, one click elsewhere — and deliberately absent from the Evaluated
   and Verdict story rows, which are meant to scan. */

export function Receipt({ quote, timestamp, open = false }) {
  const [shown, setShown] = useState(open);
  if (!quote) return null;
  if (!shown) {
    return (
      <button type="button" className="dp-receipt-btn" onClick={() => setShown(true)}>
        + receipt
      </button>
    );
  }
  return (
    <div className="dp-receipt">
      <p>{quote}</p>
      {timestamp && timestamp !== '—' && <span className="dp-ts">{timestamp}</span>}
    </div>
  );
}

export function Meter({ value, max = 10, tone }) {
  return (
    <span className={`dp-meter dp-meter-${tone || (value >= 7 ? 'hi' : value <= 4 ? 'lo' : 'mid')}`}>
      <span className="dp-meter-fill" style={{ width: `${(value / max) * 100}%` }} />
      <span className="dp-meter-val">{value}</span>
    </span>
  );
}

export function GapRow({ importance, satisfaction }) {
  const gap = importance - satisfaction;
  return (
    <div className="dp-gap">
      <div className="dp-gap-track">
        <span className="dp-gap-fill" style={{ left: `${satisfaction * 10}%`, width: `${gap * 10}%` }} />
        <span className="dp-gap-tick dp-tick-sat" style={{ left: `${satisfaction * 10}%` }}>
          <em>{satisfaction}</em>
        </span>
        <span className="dp-gap-tick dp-tick-imp" style={{ left: `${importance * 10}%` }}>
          <em>{importance}</em>
        </span>
      </div>
      <div className="dp-gap-keys">
        <span>satisfaction</span>
        <strong>gap {gap}</strong>
        <span>importance</span>
      </div>
    </div>
  );
}

export function Panel({ label, kicker, title, meta: panelMeta, children }) {
  return (
    <section className="dp-panel">
      <header className="dp-panel-head">
        <div className="dp-panel-id">
          <span className="dp-dot" />
          <span className="dp-panel-label">{label}</span>
          <span className="dp-panel-kicker">{kicker}</span>
        </div>
        <h3>{title}</h3>
        {panelMeta && <span className="dp-panel-meta">{panelMeta}</span>}
      </header>
      <div className="dp-panel-body">{children}</div>
    </section>
  );
}

/* Simple spark mark for the Claude connector section. Deliberately generic —
   ship the official Anthropic partner asset (per their brand guidelines)
   before making partner claims prominent. */
export function ClaudeMark() {
  return (
    <svg
      className="dp-claude-mark"
      viewBox="0 0 24 24"
      width="22"
      height="22"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="currentColor">
        {Array.from({ length: 12 }).map((_, i) => (
          <rect
            key={i}
            x="11"
            y="1.5"
            width="2"
            height="7"
            rx="1"
            transform={`rotate(${i * 30} 12 12)`}
          />
        ))}
      </g>
    </svg>
  );
}
